import { useEffect, useState } from 'react'
import { Dimensions, Platform, StatusBar } from 'react-native'

export function useAndroidNavBarHeight() {
    const [navBarHeight, setNavBarHeight] = useState(0)

    useEffect(() => {
        if (Platform.OS == 'ios') setNavBarHeight(20)
        if (Platform.OS != 'android') return
        const windowHeight = Dimensions.get('window').height
        const screenHeight = Dimensions.get('screen').height

        // Diferencia = área ocupada por nav bar (y a veces status bar)
        const diff = screenHeight - windowHeight - (StatusBar.currentHeight || 0)

        // Evita valores negativos o muy altos
        console.log('Android nav bar height calculated: ====>', diff)
        let final = diff > 48 ? 48 : diff
        setNavBarHeight(diff > 0 && diff < 200 ? final : 48)
    }, [])

    return navBarHeight
}

//  useEffect(() => {
//      if (Platform.OS == 'ios') setNavBarHeight(20)
//      if (Platform.OS != 'android') return
//      const { height: windowHeight, fontScale } = Dimensions.get('window')
//      const { height: screenHeight } = Dimensions.get('screen')

//      const statusBarHeight = StatusBar.currentHeight || 0

//      const diff = screenHeight - windowHeight - statusBarHeight

//      const fixedDiff = diff / fontScale
//      // Evita valores negativos o muy altos
//      console.log('Android nav bar height calculated: ====>', diff, fixedDiff)
//      setNavBarHeight(fixedDiff > 0 && fixedDiff < 200 ? fixedDiff : 0)
//  }, [])
